"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var redirect_1 = require("../../../build-babel/redirect");
var B2C_PASSWORD_RESET_CANCEL_ERROR_CODE = 'AADB2C90091'; // The user has canceled entering self-asserted information
var handleError = function handleError(error) {
  if ((error === null || error === void 0 ? void 0 : error.errorMessage) && error.errorMessage.indexOf(B2C_PASSWORD_RESET_CANCEL_ERROR_CODE) !== -1) {
    (0, redirect_1.redirectToAuth)();
  } else {
    (0, redirect_1.redirectNext)();
  }
};
exports["default"] = handleError;
//# sourceMappingURL=error.js.map